import {
  DoubleArrowLeftIcon,
  DoubleArrowRightIcon,
  DragHandleDots2Icon,
} from "@radix-ui/react-icons";
import type { RefObject } from "react";
import * as ResizablePrimitive from "react-resizable-panels";

import { cn } from "@/lib/utils";

const ResizablePanelGroup = ({
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) => (
  <ResizablePrimitive.PanelGroup
    className={cn(
      "flex h-full w-full data-[panel-group-direction=vertical]:flex-col",
      className,
    )}
    {...props}
  />
);

const ResizablePanel = ResizablePrimitive.Panel;

const ResizableToggle = ({
  panelRef,
  className,
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
  panelRef: RefObject<ResizablePrimitive.ImperativePanelHandle>;
}) => {
  const handleTogglePanel = () => {
    const panel = panelRef.current;

    if (panel) {
      if (panel.isCollapsed()) {
        panel.expand();
      } else {
        panel.collapse();
      }
    }
  };

  return (
    <button
      type="button"
      className={cn("mr-[-9px] z-10", className)}
      onClick={handleTogglePanel}
    >
      <div className="z-10 flex h-5 w-4 items-center justify-center rounded-sm border bg-border">
        <DoubleArrowRightIcon className="h-3 w-3" />
      </div>
    </button>
  );
};

const ResizableHandle = ({
  withHandle,
  withToggle,
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
  withHandle?: boolean;
  withToggle?: boolean;
}) => {
  return (
    <ResizablePrimitive.PanelResizeHandle
      className={cn(
        "relative flex w-px items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:-translate-y-1/2 data-[panel-group-direction=vertical]:after:translate-x-0 [&[data-panel-group-direction=vertical]>div]:rotate-90",
        className,
      )}
      {...props}
    >
      {withHandle && (
        <div className="z-10 flex h-5 w-4 items-center justify-center rounded-sm border bg-border">
          <DragHandleDots2Icon className="h-3 w-3" />
        </div>
      )}
    </ResizablePrimitive.PanelResizeHandle>
  );
};

export {
  ResizablePanelGroup,
  ResizablePanel,
  ResizableHandle,
  ResizableToggle,
};
